import { render } from "./Index.vue?vue&type=template&id=aa99e7c6"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Logistics/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aa99e7c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aa99e7c6', __exports__)) {
    console.log('reload')
    api.reload('aa99e7c6', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=aa99e7c6", () => {
    console.log('re-render')
    api.rerender('aa99e7c6', render)
  })

}


export default __exports__